import { Editor } from '@ckeditor/ckeditor5-core/src/editor';
import { Divider } from 'antd';
import React, { FC } from 'react';
import { IconWrapper } from 'components/atoms/icon-shell/icon-shell';
import { HeadingDropdown } from '../heading-dropdown';
import styles from './styles.module.css';
import { ToolButton } from './tool-button';
import { tools as defaultTools } from './tools';
import { Tool, Tools } from './types.d';
import { checkActiveState, checkDefaultEnabled } from './utils';

interface Props {
  editor: Editor;
  tools?: Tools;
  className?: string;
}

export const renderToolbarButton = ({
  key,
  Component,
  data,
  label,
  haveItsOwnHandler,
  keyStroke,
  componentProps = {},
  editor,
}: Tool & { editor: Editor }): JSX.Element =>
  haveItsOwnHandler ? (
    <div key={`${key}-${data}`}>
      <IconWrapper>
        {React.createElement(Component, {
          editor,
          ...componentProps,
        })}
      </IconWrapper>
    </div>
  ) : (
    <ToolButton
      commandName={key}
      commandValue={data}
      editor={editor}
      label={label}
      keyStroke={keyStroke}
      haveItsOwnHandler={false}
      key={`${key}-${data}`}
      command={editor?.commands.get(key)}
      haveActiveState={checkActiveState(key)}
      enabled={checkDefaultEnabled(key)}
    >
      <IconWrapper>
        {React.createElement(Component, {
          editor,
          ...componentProps,
        })}
      </IconWrapper>
    </ToolButton>
  );

export const ToolsRenderer = ({
  tools = [],
  editor,
}: Omit<Props, 'className'>) => {
  return (
    <>
      {tools.map(({ group, items }, index) => (
        <>
          <div
            className={styles[group]}
            key={group}
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {(items as Tool[]).map((e) =>
              renderToolbarButton({ ...e, editor }),
            )}
          </div>
          {index < tools.length - 1 ? (
            <Divider type="vertical" style={{ height: '24px' }} />
          ) : null}
        </>
      ))}
    </>
  );
};

export const DocumentToolbar: FC<Props> = ({
  editor,
  tools = defaultTools,
  className = '',
}: Props) => (
  <div className={`${styles.toolbar} ${className}`} data-preview-disable="true">
    <HeadingDropdown editor={editor} />
    <ToolsRenderer tools={tools} editor={editor} />
  </div>
);
